import { render, staticRenderFns } from "./category-top-panel.vue?vue&type=template&id=62c0646e&"
import script from "./category-top-panel.vue?vue&type=script&lang=js&"
export * from "./category-top-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports